import Dexie from 'dexie';

// IndexedDB for offline storage
export const db = new Dexie('GalldrisCoreDB');

db.version(1).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced',
  inductions: '++id, user_id, site_id, induction_date, synced',
  syncQueue: '++id, entity_type, operation, timestamp, synced'
});

db.version(2).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status'
});

db.version(3).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  goodCalls: '++id, project_id, reported_by, created_at, synced',
  ramsDocuments: '++id, project_id, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status'
});

db.version(4).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  goodCalls: '++id, project_id, reported_by, created_at, synced',
  ramsDocuments: '++id, project_id, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status',
  apiCache: 'url, timestamp'
});

db.version(5).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  goodCalls: '++id, project_id, reported_by, created_at, synced',
  ramsDocuments: '++id, project_id, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status',
  apiCache: 'url, timestamp',
  // Cached reference/dropdown data for offline use
  referenceData: '[key+scope], key, scope, updated_at'
});

db.version(6).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  goodCalls: '++id, project_id, reported_by, created_at, synced',
  ramsDocuments: '++id, project_id, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status',
  apiCache: 'url, timestamp',
  referenceData: '[key+scope], key, scope, updated_at',
  // RAMS document blob cache for offline viewing (keyed by ramsId)
  ramsBlobCache: 'ramsId'
});

db.version(7).stores({
  timesheets: '++id, user_id, site_id, clock_in, synced',
  incidents: '++id, site_id, reported_by, incident_date, synced',
  deliveries: '++id, site_id, delivery_date, synced',
  inspections: '++id, site_id, inspector_id, inspection_date, synced, project_id',
  inductions: '++id, user_id, site_id, induction_date, synced, project_id',
  closeCalls: '++id, project_id, reported_by, created_at, synced',
  goodCalls: '++id, project_id, reported_by, created_at, synced',
  ramsDocuments: '++id, project_id, created_at, synced',
  files: '++id, sync_queue_id, field_name, file_name, mime_type',
  syncQueue: '++id, entity_type, operation, timestamp, synced, status',
  apiCache: 'url, timestamp',
  referenceData: '[key+scope], key, scope, updated_at',
  ramsBlobCache: 'ramsId',
  assetRegisterRecords: '++id, project_id, variant, client_id, sync_queue_id, record_id, synced, created_at',
  assetDailyChecks: '++id, record_id, variant, client_id, sync_queue_id, synced, submitted_at'
});

// Add item to sync queue
export async function addToSyncQueue(entityType, operation, data) {
  await db.syncQueue.add({
    entity_type: entityType,
    operation,
    data,
    timestamp: new Date().toISOString(),
    synced: 0
  });
}

// Get unsynced items (supports both legacy boolean false and new numeric 0)
export async function getUnsyncedItems() {
  return await db.syncQueue.filter(item => item.synced === 0 || item.synced === false).toArray();
}

// Mark items as synced
export async function markAsSynced(ids) {
  await db.transaction('rw', db.syncQueue, async () => {
    for (const id of ids) {
      await db.syncQueue.update(id, { synced: 1 });
    }
  });
}

// Save offline data
export async function saveOfflineData(table, data) {
  const item = { ...data, synced: 0, offline_created: true };
  const id = await db[table].add(item);
  
  // Add to sync queue
  await addToSyncQueue(table, 'create', { ...item, id });
  
  return id;
}

// Update offline data
export async function updateOfflineData(table, id, data) {
  await db[table].update(id, { ...data, synced: 0 });
  
  // Add to sync queue
  await addToSyncQueue(table, 'update', { id, ...data });
}

// Delete offline data
export async function deleteOfflineData(table, id) {
  await db[table].delete(id);
  
  // Add to sync queue
  await addToSyncQueue(table, 'delete', { id });
}

// Get pending sync count (supports both legacy boolean false and new numeric 0)
export async function getPendingSyncCount() {
  return await db.syncQueue.filter(item => item.synced === 0 || item.synced === false).count();
}

// Save a file blob for offline sync
export async function saveOfflineFile(syncQueueId, fieldName, fileName, mimeType, blob) {
  return await db.files.add({
    sync_queue_id: syncQueueId,
    field_name: fieldName,
    file_name: fileName,
    mime_type: mimeType,
    blob
  });
}

// Get files for a sync queue item
export async function getFilesForSyncItem(syncQueueId) {
  return await db.files.where('sync_queue_id').equals(syncQueueId).toArray();
}

// Delete files for a sync queue item
export async function deleteFilesForSyncItem(syncQueueId) {
  return await db.files.where('sync_queue_id').equals(syncQueueId).delete();
}

// RAMS document blob cache (for offline viewing)
const RAMS_BLOB_CACHE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days

export async function getRAMSBlobFromCache(ramsId, ignoreExpiry = false) {
  try {
    const record = await db.ramsBlobCache.get(ramsId);
    if (!record || !record.blob) return null;
    if (!ignoreExpiry && record.updated_at && Date.now() - record.updated_at > RAMS_BLOB_CACHE_TTL) return null;
    return record.blob;
  } catch (err) {
    console.warn('[db] getRAMSBlobFromCache failed:', err);
    return null;
  }
}

export async function setRAMSBlobCache(ramsId, blob, mimeType = 'application/pdf') {
  try {
    await db.ramsBlobCache.put({ ramsId, blob, mimeType, updated_at: Date.now() });
  } catch (err) {
    console.warn('[db] setRAMSBlobCache failed:', err);
  }
}

export default db;

